export const formatDate = (value) => {
    let month = '' + (value.getMonth() + 1),
        day = '' + value.getDate(),
        year = value.getFullYear();
    if (month.length < 2)
        month = '0' + month;
    if (day.length < 2)
        day = '0' + day;
    return [day, month, year].join('/');
}